import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateEstadoCasoRequest extends CreateKeyValueRequest
{

}
